module.exports = "img/flags/CV.ae86343.png";